import styled from "styled-components";

import Drawer from "@material-ui/core/Drawer";

export const Container = styled(Drawer)`
    z-index: 1299;

    & > div {
        @media screen and (max-width: 575px) {
            top: 100px !important;
        }
    }

    & .scrollbar > div {
        overflow: hidden !important;

        & > ul {
            margin-right: 15px;
        }
    }

    & > .side-nav {
        &::-webkit-scrollbar {
            width: 5px;
        }

        &::-webkit-scrollbar-track,
        &::-webkit-scrollbar-thumb {
            border-radius: 100px;
            border: 0px solid #ff6e0d;
            margin-bottom: 50px;
        }

        &::-webkit-scrollbar-track {
            background: var(--gray);
        }

        &::-webkit-scrollbar-thumb {
            background: var(--orange);
        }
        &::-webkit-scrollbar-thumb:hover {
            background: var(--orange);
        }
    }
`;

export const Burguer = styled.div`
    display: flex;
    justify-content: ${({ collapsed }) => (collapsed ? "center" : "flex-end")};
    align-items: flex-end;

    padding-top: 15px;
    padding-bottom: 65px;
    padding-right: ${({ collapsed }) => !collapsed && "15px"};

    cursor: pointer;

    @media screen and (max-width: 575px) {
        margin-bottom: 50px !important;
    }
`;
